export default __webpack_public_path__ + "static/media/logo1.f546e45d.webp";